// removed by extract-text-webpack-plugin
module.exports = {"animationWrapper":"_322h79yWb0Ilxh1I7GxUNF","captionWrapper":"_1yPjyJQ05nmj_E6__C_EjM","caption":"_1OwNjzs8eYnodZLkLZgyyX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FeatureMediaWithCaption/FeatureMediaWithCaption.module.scss
// module id = 763
// module chunks = 0